document.addEventListener('DOMContentLoaded', function() {
  const toggleButtons = document.querySelectorAll('.global-nav__subitem span');
  const inlineMenu = document.querySelector('.header__inline-menu');
  const closeButtons = document.querySelectorAll('.dropdown__btn-close');

  toggleButtons.forEach(function(button) {
    const dropdown = button.closest('.global-nav__subitem').querySelector('.dropdown__wrap');

    // 各ボタンにクリックイベントを追加
    button.addEventListener('click', function(event) {
      // 他のナビゲーションを閉じる
      document.querySelectorAll('.dropdown__wrap.show').forEach(function(openDropdown) {
        if (openDropdown !== dropdown) {
          openDropdown.classList.remove('show');
        }
      });

      // 対応するナビゲーションの開閉をトグル
      dropdown.classList.toggle('show');
      event.stopPropagation(); // クリックイベントをバブルアップしない
    });
  });

  // 各closeButtonにクリックイベントを追加
  closeButtons.forEach(function(button) {
    button.addEventListener('click', function(event) {
      const dropdown = button.closest('.dropdown__wrap');
      dropdown.classList.remove('show');
      event.stopPropagation(); // クリックイベントをバブルアップしない
    });
  });

  // .header__inline-menu以外をクリックしたときにナビゲーションを閉じる
  document.addEventListener('click', function(event) {
    if (!inlineMenu.contains(event.target)) {
      document.querySelectorAll('.dropdown__wrap.show').forEach(function(openDropdown) {
        openDropdown.classList.remove('show');
      });
    }
  });
});


document.addEventListener("DOMContentLoaded", function() {
  const menuItems = document.querySelectorAll('.menu-drawer__sub__inner');

  menuItems.forEach(item => {
    const link = item.querySelector('h3');
    const subMenu = item.querySelector('ul');

    link.addEventListener('click', function(e) {
      e.preventDefault(); // リンクのデフォルト動作を防止

      // 他のサブメニューを閉じる
      menuItems.forEach(otherItem => {
        if (otherItem !== item) {
          const otherSubMenu = otherItem.querySelector('ul');
          const otherLink = otherItem.querySelector('h3');
          if (otherSubMenu) {
            otherSubMenu.classList.remove('open');
          }
          if (otherLink) {
            otherLink.classList.remove('active');
          }
        }
      });

      // サブメニューのトグル
      if (subMenu) {
        subMenu.classList.toggle('open');
      }
      link.classList.toggle('active');
    });
  });
});
